module.exports = __webpack_public_path__ + "static/media/witryna_01_C.9cdcbc57.png";